import React from 'react';
import { Col, UncontrolledCollapse } from 'reactstrap';
import { FaUserCircle } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import styles from './collapse-user.module.scss';
import IUser from '../models/user.model';

interface ILanguage {
  label: string;
  id: number;
}

interface CollapseUserProps {
  user: IUser | undefined;
  userImage?: string;
  filterGroups: (item: any) => boolean;
  currentLang: ILanguage;
}

const translations = {
  ES: {
    logout: "Cerrar Sesión",
    role: "Rol",
    country: "País",
    permissions: "Permisos"
  },
  EN: {
    logout: "Logout",
    role: "Role",
    country: "Country",
    permissions: "Permissions"
  },
  PT: {
    logout: "Sair",
    role: "Função",
    country: "País",
    permissions: "Permissões"
  }
} as const;

const CollapseUserComponent: React.FC<CollapseUserProps> = ({ user, userImage, filterGroups, currentLang }) => {
  const { logout, role, country, permissions } = translations[currentLang.label as keyof typeof translations] || translations.EN;

  return (
    <UncontrolledCollapse toggler="#toggler-user">
      <Col xs={12} md={5} lg={4} className={styles.UserContainer}>
        <div className={styles.header}>
          <span className={styles.userInfo}>
            {!!userImage ? (
              <img src={userImage} style={{
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                marginRight: '10px'
              }} alt="profile image" />
            ) : <FaUserCircle size={32} className={styles.userIcon} />}
            {user && user.displayName}
          </span>
          <label className={styles.close} id="toggler-user">
            <MdClose />
          </label>
        </div>
        <div className={styles.details}>
          <p>
            {user && user.email} - {user && user.department}
          </p>
          <hr className={styles.separator} />
          <p>
            <a href="https://login.microsoftonline.com/common/oauth2/v2.0/logout" className={styles.logout}>
              {logout}
            </a>
          </p>
          <p>
            {role} - {user && user.rol}
          </p>
          <p>
            {country} - {user && user.country}
          </p>
          <hr className={styles.separator} />
          <p style={{ color: '#f03500' }}>
            {permissions}
          </p>
          <div className={styles.groups}>
            {user && user.groups.filter(filterGroups).map((group) => (
              <p key={group.id}>
                {group.name}
              </p>
            ))}
          </div>
        </div>
      </Col>
    </UncontrolledCollapse>
  );
};

export default CollapseUserComponent;
